import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { App } from './App';
import { initStoreFrontSentry } from './lib/sentry';
import { forceReloadForFreshChunks } from './lib/lazyWithReload';
import './i18n';
import './globals.css';
import './index.css';
// aikka OS brand system. Safe to load globally: scripts/check-os-da.mjs proves
// none of its unscoped utility classes collides with the other 8 stylesheets,
// and its tokens only apply inside `.os-scope`.
import './os/os.css';
// Re-themes the legacy marketing stylesheets inside `.os-scope` by overriding
// the custom properties they read. Must load after os.css (it depends on its
// tokens) and after index.css (which pulls in styles/*.css).
import './os/os-legacy-bridge.css';

initStoreFrontSentry();

// Stale-chunk recovery for `<link rel="modulepreload">` failures. Vite fires
// `vite:preloadError` on window when a preloaded chunk 404s — which is exactly
// what happens to a tab left open across a deploy (old index.html → purged
// hashes). Recover with the SAME one-reload-per-session budget the lazy()
// wrappers use, so a preload failure and a lazy failure can never stack into a
// reload loop. Calling preventDefault() stops Vite from also throwing.
window.addEventListener('vite:preloadError', (event) => {
  if (forceReloadForFreshChunks()) {
    event.preventDefault();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p className="p-4 text-sm text-plum">Something went wrong.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
